import 'ol/ol.css';
import { Map as OlMap, View, Overlay } from 'ol';
import { defaults as defaultControls } from 'ol/control';
import { fromLonLat, get as getProjection } from 'ol/proj';
import { Tile as TileLayer } from 'ol/layer'
import { XYZ } from 'ol/source'
import { getViewport } from 'utils/commonFunc';
import SelectLink2PolygonLayer from 'map/layers/SelectLink2PolygonLayer'
import IntersectionPointLayer from 'map/layers/IntersectionPointLayer'
import TooltipVectorLayer from 'map/layers/TooltipVectorLayer';
import FacilityStatusLayer from 'map/layers/FacilityStatusLayer';
import EmergencyVehicleLayer from 'map/layers/EmergencyVehicleLayer';
import BoundaryPolygonLayer from './layers/BoundaryPolygonLayer';
import DisplayLink2PolygonLayer from './layers/DisplayLink2PolygonLayer';
import DisplayIntersectionPointLayer from './layers/DisplayIntersectionPointLayer';
import { getTileLayers } from './OlExtension';

const mapProjection = 'EPSG:900913';
export default class SuwonMapCore extends OlMap {
    constructor(target, options = {}) {
        const { lightMode = false } = options;

        // super({
        //     target: target,
        //     controls: defaultControls({ zoom: true, rotate: false }).extend([]),
        //     layers: lightMode ? 
        //      //   [...getTileLayers({tileUrl: 'http://api.vworld.kr/req/wmts/1.0.0/33472E74-6D5A-38C5-9ED1-299F89762FDF/Base/{z}/{y}/{x}.png'})] :
        //      //   [...getTileLayers({tileUrl: 'http://192.168.0.190:8005/vworld/Base/{z}/{y}/{x}.png'})] :
        //         // [...getTileLayers({tileUrl:window.serviceConfig?.tileUrl})],
        //         layers: [...getTileLayers({tileUrl:window.serviceConfig?.tileUrl})],
        //     view: new View({
        //         projection: getProjection(mapProjection),
        //         center: [14140005.444591135, 4477082.388739058], //[fromLonLat([127.0480244, 37.2993926])],
        //         zoom: (getViewport().width > getViewport().height * 1.2) ? 14 : 12, //14
        //         minZoom: 9,
        //         maxZoom: 18,
        //     }),
        // });
        super({
            target: target,
            controls: defaultControls({ zoom: true, rotate: false }).extend([]),
            // layers: [...getTileLayers({ tileUrl: window.serviceConfig?.tileUrl })],  // 중복 제거
            layers: [...getTileLayers({ tileUrl: "/vworld/Base/{z}/{y}/{x}.png" })],
            view: new View({
                projection: getProjection(mapProjection),
                center: [14140005.444591135, 4477082.388739058],
                zoom: (getViewport().width > getViewport().height * 1.2) ? 14 : 12,
                minZoom: 9,
                maxZoom: 18,
            }),
        });

        this.defaultViewInfo = { zoom: this.getView().getZoom() - 1, center: this.getView().getCenter() }
    }

    setTooltipLayer = (options = {}) => {
        const layer = new TooltipVectorLayer(this, options);
        this.addLayer(layer);
        this.tooltipLayer = layer;
    }

    addSelectLink2GeoJson = (data) => {
        const layer = new SelectLink2PolygonLayer(this, data, mapProjection);
        this.addLayer(layer);
        return layer;
    }

    addDisplayLink2GeoJson = (data) => {
        const layer = new DisplayLink2PolygonLayer(this, data, mapProjection);
        this.addLayer(layer);
        return layer;
    }

    addDisplayIntersectionGeoJson = (data) => {
        const layer = new DisplayIntersectionPointLayer(this, data, mapProjection);
        this.addLayer(layer);
        return layer;
    }

    addBoundaryGeoJson = (data) => {
        this.getAllLayers().forEach(lay => lay.setVisible(false))
        this.removeControls()

        const layer = new BoundaryPolygonLayer(this, data, mapProjection);
        this.addLayer(layer);
        return layer;
    }

    addIntersectionGeoJson = (data) => {
        const layer = new IntersectionPointLayer(this, data, mapProjection);
        this.addLayer(layer);
        return layer;
    }

    addFacilityStatusLayer = (data) => {
        const layer = new FacilityStatusLayer(this, data);
        this.addLayer(layer);
        layer.createValidAnimationFeatures();
        layer.validAnimation(3000);
        return layer;
    }

    addOverlayTarget = (target) => {
        const overlay = new Overlay({
            element: target,
            positioning: 'bottom-left',
            offset: [0, -10],
        });

        this.addOverlay(overlay);

        return overlay;
    }

    setDefaultViewZoom = () => {
        const view = this.getView();
        if (view) {
            view.setZoom(this.defaultViewInfo.zoom);
            view.setCenter(this.defaultViewInfo.center);
        }
    }

    addEmergencyVehicleLayer = () => {
        const layer = new EmergencyVehicleLayer(this);
        this.addLayer(layer);
        return layer;
    }

    removeControls = () => {
        this.getControls().forEach(control => this.removeControl(control));
    }
}